import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import BaseCard from "@app/components/card/card";
import { Button, Popover, Tag } from "antd";
import { DeleteOutlined, EditOutlined, FileTextOutlined } from "@ant-design/icons";

import "./styles/card.scoped.scss";
import "./styles/usage-popover.scss";

const Card = observer(
    ({ entry, short, readonly, onClick, onEdit, onRemove, usageStat, ...rest }) => {
        /**
         * Handle edit button click
         */
        const edit = (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (onEdit) {
                onEdit(entry, event);
            }
        };

        /**
         * Handle delete button click
         */
        const remove = (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (onRemove) {
                onRemove(entry, event);
            }
        };

        return (
            <BaseCard className={classNames("entry-card", { short })} onClick={onClick} {...rest}>
                <div className="name">{entry.name}</div>
                <div className="text">{entry.text}</div>

                <div className="usage-tag">
                    {!usageStat || usageStat.count === 0 ? (
                        <Tag>Not in Use</Tag>
                    ) : (
                        <Popover
                            trigger="hover"
                            placement="rightTop"
                            title={
                                <span className="usage-popover-title">
                                    <FileTextOutlined />
                                    {usageStat.documents.length === 1
                                        ? `Used in:`
                                        : `Used in these documents:`}
                                </span>
                            }
                            content={
                                <div className="usage-popover-content">
                                    {usageStat.documents.map((doc, index) => (
                                        <div key={String(doc._id)} className="usage-popover-doc">
                                            <span className="doc-index">{index + 1}.</span>
                                            <span className="doc-name">{doc.name}</span>
                                        </div>
                                    ))}
                                </div>
                            }
                        >
                            <Tag className="usage-tag-clickable">
                                Used {usageStat.count} {usageStat.count === 1 ? "time" : "times"}
                            </Tag>
                        </Popover>
                    )}
                </div>

                {!readonly && (
                    <div className="actions">
                        {onEdit && (
                            <Button onClick={edit} type="icon" icon={<EditOutlined />}></Button>
                        )}
                        {onRemove && (
                            <Button
                                onClick={remove}
                                type="icon"
                                danger
                                icon={<DeleteOutlined />}
                            ></Button>
                        )}
                    </div>
                )}
            </BaseCard>
        );
    },
);

export default Card;
